module.exports = __webpack_public_path__ + "img/hp-case-green.6de9f8ce.png";